<p>static-pagination works!</p>
